import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    ConsumedBalanceByCustomer : [],
    loading : false,
    error : null,
};

const fetchConsumedBalanceByCustomerSlice = createSlice({
    name:"fetchConsumedBalanceByCustomer",
    initialState,
    reducers: {
        fetchConsumedBalanceByCustomerSuccess: (state,action) => {
            state.loading = false;
            state.ConsumedBalanceByCustomer = action.payload
        },
        fetchConsumedBalanceByCustomerFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    }
})

export const {
    fetchConsumedBalanceByCustomerFailure,
    fetchConsumedBalanceByCustomerSuccess
} = fetchConsumedBalanceByCustomerSlice.actions

export default fetchConsumedBalanceByCustomerSlice.reducer